import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { NoteFormPage } from "~/pages/NoteFormPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/notes/create")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Notes", link: `/${datasetSlug}/notes` }, { title: "Create", link: `/${datasetSlug}/notes/create` }]);
  return <NoteFormPage />;
}
